import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { CustomerCourtBookingStep2 } from "./CustomerCourtBookingStep2";
import { CustomerCourtBookingSummary } from "./CustomerCourtBookingSummary";
import { useLocation } from "react-router-dom";

const CustomerCourtBookingReschedule = () => {
  const data = useLocation().state;

  const [currentStep, setCurrentStep] = useState(0);
  const [courtBookingRescheduleData, setCourtBookingRescheduleData] = useState({
    ...data,
    selectedSlots: [],
    cancelledSlots: [],
  });

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            {currentStep !== 0 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {currentStep === 0 && (
              <CustomerCourtBookingStep2
                courtBookingData={courtBookingRescheduleData}
                setCourtBookingData={setCourtBookingRescheduleData}
                setCurrentStep={setCurrentStep}
                isReschedule={true}
              />
            )}
            {currentStep === 1 && (
              <CustomerCourtBookingSummary
                slotId={data.slotId}
                courtBookingData={courtBookingRescheduleData}
                isReschedule={true}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CustomerCourtBookingReschedule };
